var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophoneOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_6752)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M86.4998 52.1946C86.6353 49.2561 84.3601 46.774 81.4073 46.6242C78.4617 46.4816 75.9368 48.7425 75.7656 51.6811C75.7656 51.7381 75.3876 57.6651 71.7572 63.3496C67.107 70.6389 59.1972 74.3334 48.2419 74.3334C37.2866 74.3334 29.3768 70.6389 24.7265 63.3496C21.1318 57.7222 20.7324 51.8522 20.7181 51.6882C20.5683 48.7497 18.0292 46.4816 15.1121 46.6171C12.145 46.7526 9.85556 49.2489 9.99107 52.2017C10.0053 52.5084 11.7028 81.3731 42.2792 84.711V97H54.2045V84.711C84.7881 81.3731 86.4784 52.5084 86.4927 52.2017L86.4998 52.1946Z",
    fill: "url(#paint0_linear_197_6752)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.5297 17.4744C27.4727 18.0877 27.437 18.7083 27.437 19.3359V48.0864C27.437 58.7636 36.0957 67.4222 46.7728 67.4222H49.7114C60.3885 67.4222 69.0472 58.7636 69.0472 48.0864V19.3359C69.0472 18.8794 69.0258 18.423 68.9972 17.9736C60.8663 24.8635 35.3254 24.2358 27.5297 17.4744Z",
    fill: "url(#paint1_linear_197_6752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7182 0H46.7797C36.7302 0 28.471 7.66728 27.5366 17.4743C35.3323 24.2357 60.8732 24.8562 69.0041 17.9735C68.3052 7.93118 59.9389 0 49.7254 0H49.7182Z",
    fill: "url(#paint2_linear_197_6752)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_6752",
    x1: 47.9352,
    y1: 66.3523,
    x2: 47.4787,
    y2: 87.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_6752",
    x1: 47.9211,
    y1: 67.2725,
    x2: 48.5773,
    y2: -0.977034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_6752",
    x1: 48.2632,
    y1: 0.891544,
    x2: 48.2632,
    y2: 25.6265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_6752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOn);
export default __webpack_public_path__ + "static/media/MicrophoneOn.ea16a0590aa6e50bea5f1ec52fe09d82.svg";
export { ForwardRef as ReactComponent };